$(document).ready(function () {
    let tamanho = $(".conteudo-blog h2").length;
    let sumario = document.createElement("div")
    let sumarioHeader = document.createElement("div")
    let sumarioList = document.createElement("ol")
    let sumarioTitle = document.createElement("h4")
    let sumarioButtom = document.createElement("button")
    let sumarioIcon = document.createElement("i")
    var textTitle = document.createTextNode("Neste artigo, você verá:");
    sumario.classList.add("sumario")
    sumarioHeader.classList.add("sumario-header")
    sumarioIcon.classList.add("fas")
    sumarioIcon.classList.add("fa-bars")
    for (let i = 0; i < tamanho; i++) {
        $(".conteudo-blog h2")[i].id = `subtitulo-${i}`;
        let sumarioItem = document.createElement("a")
        let sumarioItemText = document.createElement("li")
        var text = document.createTextNode($(".conteudo-blog h2")[i].innerText);
        sumarioItem.href = `#subtitulo-${i}`
        sumarioItemText.appendChild(text)
        sumarioItem.append(sumarioItemText)
        sumarioList.append(sumarioItem);
    }
    sumarioButtom.appendChild(sumarioIcon)
    sumarioTitle.appendChild(textTitle)
    sumarioHeader.append(sumarioTitle)
    sumarioHeader.append(sumarioButtom)
    sumario.append(sumarioHeader)
    sumario.append(sumarioList)
    $(".conteudo-blog h2")[0].before(sumario)

    $(sumarioButtom).click(() => {
        $(sumarioList).toggle()
    })

    $('#btnInputNLS').click(function (event) {
        event.preventDefault();

        var nome = $('#nomeNewsLetterS').val();
        var email = $('#emailNewsLetterS').val();
        var c_umtz = read_cookie("__utmz");
        var traffic_source = read_cookie("__trf.src");
        var client_id = read_cookie("rdtrk") ? JSON.parse(decodeURIComponent(read_cookie("rdtrk"))).id : false;
        var data = {
            'nome': nome,
            'email': email,
            'c_umtz': c_umtz,
            'traffic_source': traffic_source,
            'client_id': client_id
        }
        $.ajax({
            type: "POST",
            data,
            dataType: "JSON",
            url: "https://callbacks.prestus.com.br/siteapi/v1/newsdev", //Variavel criada na criação do JS no functions
            success: function (retorno) {
                if (retorno.status == 0) {
                    let opts = {
                        title: 'Erro!',
                        text: retorno.msg,
                    };
                    PNotify.alert(opts);
                } else {
                    let opts = {
                        title: 'Sucesso',
                        text: retorno.msg,
                    };
                    PNotify.alert(opts);
                }
            }
        });
    });

    function read_cookie(a) {
        var b = a + "=";
        var c = document.cookie.split(";");
        for (var d = 0; d < c.length; d++) {
            var e = c[d];
            while (e.charAt(0) == " ") e = e.substring(1, e.length);
            if (e.indexOf(b) == 0) {
                return e.substring(b.length, e.length)
            }
        }
        return null
    }
})